import * as Yup from "yup";

import { variables } from "../Variables";

const { required, IsEmail, password_match } = variables;

export const addvalidation = Yup.object({
  email: Yup.string().required(required).email(IsEmail),
  password: Yup.string().required(required),
});

export const forgetPassword = Yup.object({
  email: Yup.string().required(required).email(IsEmail),
});

export const resetPasswordSchema = Yup.object({
  password: Yup.string().required(required),
  confirm_password: Yup.string()
    .required(required)
    .oneOf([Yup.ref("password"), null], password_match),
});
